export const purchaseIntentConstant = {
	top: 0.75,
	second: 0.25,
} as const;

export const getPurchaseIntentConstant = (purchaseIntent: number) => {
	switch (purchaseIntent) {
		case 1:
			return purchaseIntentConstant.top;
		case 2:
			return purchaseIntentConstant.second;
		default:
			return 0;
	}
};
